import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import MyButton from '../util/MyButton';
import Comments from './Comments';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
// MUI Stuff
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
// Icons
import CloseIcon from '@material-ui/icons/Close';
import UnfoldMore from '@material-ui/icons/UnfoldMore';
// import ChatIcon from '@material-ui/icons/Chat';
// import { FavoriteBorder, Favorite as FavoriteIcon}from '@material-ui/icons';
import { likeScream, unlikeScream } from '../redux/actions/dataActions';


// Redux stuff
import { connect } from 'react-redux';
import { getScream, clearErrors } from '../redux/actions/dataActions';
import CommentForm from './CommentForm';

const styles = () => ({
//   ...theme,
  profileImage: {
    maxWidth: 200,
    height: 200,
    borderRadius: '50%',
    objectFit: 'cover'
  },
  dialogContent: {
    padding: 20
  },
  closeButton: {
    position: 'absolute',
    left: '90%'
  },
  expandButton: {
    position: 'absolute',
    left: '90%'
  },
  spinnerDiv: {
    textAlign: 'center',
    marginTop: 50,
    marginBottom: 50
  }
});

class ScreamDialog extends Component {
  constructor(props){
    super(props)
    this.state = {
      open: false,
      oldPath: '',
      newPath: '',
      screams: this.props.data.screams
    
    }
  }
  // state = {
  //   open: false,
  //   oldPath: '',
  //   newPath: '',
  //   screams: this.props.data.screams
  // };
  componentDidMount() {
    if (this.props.openDialog) {
      this.handleOpen();
    }
  }
  handleOpen = () => {
    let oldPath = window.location.pathname;

    const { userHandle, screamId } = this.props;
    const newPath = `/users/${userHandle}/scream/${screamId}`;

    if (oldPath === newPath) oldPath = `/users/${userHandle}`;

    window.history.pushState(null, null, newPath);

    this.setState({ open: true, oldPath, newPath });
    this.props.getScream(this.props.screamId);
  };
  handleClose = () => {
    window.history.pushState(null, null, this.state.oldPath);
    this.setState({ open: false });
    this.props.clearErrors();
  };

  likedScream = (screamId) => {
    if (
      this.props.user.likes &&
      this.props.user.likes.find(
        (like) => like.screamId === screamId
      )
    )
      return true;
    else return false;
  };

  
  // componentWillReceiveProps(nextProps){
  //   console.log('in scream comp')
    

  //   if (nextProps.data.screams != this.state.screams ){
  //     console.log('in scream comp cond')
  
  //     console.log('in condition')
  //     this.setState({
  //       screams: nextProps.data.screams
  //     })
  //     // this.childRef.current.forceUpdate()
  //     this.forceUpdate()
  //   }
  // }
  render() {
    // console.log('rendering uppp')
    const {
      classes,
      scream: {
        screamId,
        body,
        createdAt,
        // likeCount,
        // commentCount,
        userImage,
        userHandle,
        comments
      },
      user: {authenticated, credentials: {imageUrl}},
      UI: { loading }
    } = this.props;
    // console.log('in scream disslog',userImage)
    // console.log('in scream dislog',imageUrl)

    let userImg=userImage
// console.log('in scream dislog',screamId)

    const dialogMarkup = loading ? (
      <div className={classes.spinnerDiv}>
        <CircularProgress size={200} thickness={2} />
      </div>
    ) : (
      <Grid container spacing={2}>
        <Grid item sm={5}>
          <img src={userImg} alt="Profile" className={classes.profileImage} />
        </Grid>
        <Grid item sm={7}>
          <Typography
            component={Link}
            color="primary"
            variant="h5"
            to={`/users/${userHandle}`}
          >
            @{userHandle}
          </Typography>
          <hr className={classes.invisibleSeparator} />
          <Typography variant="body2" color="textSecondary">
            {dayjs(createdAt).format('h:mm a, MMMM DD YYYY')}
          </Typography>
          <hr className={classes.invisibleSeparator} />
          <Typography variant="body1">{body}</Typography>







          {/* {!authenticated ? (
                    <Link to="/login">
                        <MyButton tip="Like">
                        <FavoriteBorder color="primary" />
                        </MyButton>
                    </Link>
                    ) : this.likedScream(screamId) ? (
                    <MyButton tip="Undo like" onClick={()=>this.props.unlikeScream(screamId)}>
                        <FavoriteIcon color="primary" />
                    </MyButton>
                    ) : (
                    <MyButton tip="Like" onClick={()=>this.props.likeScream(screamId)}>
                        <FavoriteBorder color="primary" />
                    </MyButton>
                )}           */}
                {/* <span>{likeCount} likes</span>
          <MyButton tip="comments">
            <ChatIcon color="primary" />
          </MyButton>
          <span>{commentCount} comments</span> */}




        </Grid>
        <CommentForm screamId={screamId}/>
        <Comments comments={comments} />
      </Grid>
    );
    return (
      <Fragment>
        <MyButton
          onClick={this.handleOpen}
          tip="Expand scream"
          // tipClassName={classes.expandButton}
          // styleProp={{    position: 'absolute',left: '90%'}}
        >
          <UnfoldMore color="primary" />
        </MyButton>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          fullWidth
          maxWidth="sm"
        >
          <MyButton
            tip="Close"
            onClick={this.handleClose}
            tipClassName={classes.closeButton}
          >
            <CloseIcon />
          </MyButton>
          <DialogContent className={classes.dialogContent}>
            {dialogMarkup}
          </DialogContent>
        </Dialog>
      </Fragment>
    );
  }
}

ScreamDialog.propTypes = {
  clearErrors: PropTypes.func.isRequired,
  getScream: PropTypes.func.isRequired,
  screamId: PropTypes.string.isRequired,
  userHandle: PropTypes.string.isRequired,
  scream: PropTypes.object.isRequired,
  UI: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  scream: state.data.scream,
  UI: state.UI,
  user: state.user,
  data: state.data
});

const mapActionsToProps = {
  getScream,
  clearErrors,
  likeScream,unlikeScream
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(withStyles(styles)(ScreamDialog));